export const JGGL_URLS = {
  appStore:
    'https://apps.apple.com/us/app/jggl-ai-music-video-maker/id6739490240',
  googlePlay: 'https://play.google.com/store/apps/details?id=ai.jggl.app',
  website: 'https://jggl.ai/'
} as const

export const JGGL_PROMO_CONFIG = {
  scrollThreshold: 0.28,
  dismissalDurationMs: 12 * 60 * 60 * 1000,
  pulseIntervalMs: 6000,
  storageKey: 'arena_jggl_promo_dismissed_at',
  pages: {
    '/': {
      asset: 'main',
      title: 'Turn your ideas into music.',
      cta: 'Try JGGL'
    },
    '/fans': {
      asset: 'fans',
      title: 'Sing for your club. Make it legendary.',
      cta: 'Create Track'
    },
    '/for-clubs': {
      asset: 'clubs',
      title: 'Every great club deserves a legendary anthem.',
      cta: 'Make Yours'
    }
  }
} as const

export type JgglPromoPath = keyof typeof JGGL_PROMO_CONFIG.pages
